import React, { useState } from 'react';
const ValueOfPercentage = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Please enter both values correctly');
      setResult('');
      setExplanation('');
      return;
    }
    const isPercentageOf = (parseFloat(value1) / parseFloat(value2)) * 100;
    setResult(isPercentageOf.toFixed(2));
    setExplanation(
      `${value1} is what percentage of ${value2} = (${value1} / ${value2}) * 100 = ${
        (parseFloat(value1) / parseFloat(value2)) * 100
      } = ${isPercentageOf.toFixed(2)}`
    );
    setError('');
  };
  return (
    <div dir="ltr">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          placeholder="Value 1"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px' }}
        />
        <span>is what percentage of</span>
        <input
          type="number"
          placeholder="Value 2"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px', marginLeft: '5px', marginRight: '5px' }}
        />
        <button
          className="btn btn-success"
          style={{ fontSize: '20px'}}
          onClick={handleCalculate}
        >
          Calculate
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Result: {value1} is {result}% of {value2}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Solution Steps: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ValueOfPercentage;
